import {
  GET_ALL_REGISTERED_CM_ICA,
  GET_ALL_REGISTERED_CM_SUCCESS_ICA,
  GET_ALL_REGISTERED_CM_FAILURE_ICA,

  GET_CM_ICA_BY_ID,
  GET_CM_ICA_BY_ID_SUCCESS,
  GET_CM_ICA_BY_ID_FAILURE,
  GET_CM_ICA_BY_ID_RESET,

  EXPORT_CM_TRAINING,
  EXPORT_CM_TRAINING_SUCCESS,
  EXPORT_CM_TRAINING_FAILURE,
  EXPORT_CM_TRAINING_RESET,

  GET_ALL_ICA_NO_PAGINATION,
  GET_ALL_ICA_NO_PAGINATION_SUCCESS,
  GET_ALL_ICA_NO_PAGINATION_FAILURE,
  GET_ALL_ICA_NO_PAGINATION_FAILURE_RESET

} from "../ActionTypes";

const INIT_STATE = {
  listOfRegisteredCmIca: [],
  fetchingRegisteredCm: false,
  fetchRegisteredCmSuccess: false,
  registeredCmMetaData: '',

  fetchingCmIca: false,
  fetchCmIcaSuccess: false,
  cmIca: null,

  exportingIncampTraining: false,
  exportIncampTraining: false,

  fetchingAllIcaNoPagination: false,
  fetchAllIcaNoPaginationSuccess: false,
  allIcaNoPagination: []
}

function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case GET_ALL_REGISTERED_CM_ICA: return {
      ...state,
      fetchingRegisteredCm: true,
    }

    case GET_ALL_REGISTERED_CM_SUCCESS_ICA: return {
      ...state,
      fetchRegisteredCmSuccess: true,
      fetchingRegisteredCm: false,
      listOfRegisteredCmIca: action.payload.data,
      registeredCmMetaData: action.payload.meta,
    }

    case GET_ALL_REGISTERED_CM_FAILURE_ICA: return {
      ...state,
      fetchRegisteredCmSuccess: false,
      fetchingRegisteredCm: false
    }

    case GET_CM_ICA_BY_ID: return {
      ...state,
      fetchingCmIca: true,
    }

    case GET_CM_ICA_BY_ID_SUCCESS: {
      console.log(action)
      return {
        ...state,
        fetchingCmIca: false,
        fetchCmIcaSuccess: true,
        cmIca: action.payload.data
      }
    }

    case GET_CM_ICA_BY_ID_FAILURE: return {
      ...state,
      fetchingCmIca: false,
      fetchCmIcaSuccess: false,
    }

    case GET_CM_ICA_BY_ID_RESET: return {
      ...state,
      fetchingCmIca: false,
      fetchCmIcaSuccess: false,
      cmIca: null,
    }


    case EXPORT_CM_TRAINING: return {
      ...state,
      exportIncampTraining: true,
    }

    case EXPORT_CM_TRAINING_SUCCESS: return {
      ...state,
      exportingIncampTraining: false,
      exportIncampTraining: true,
    }


    case EXPORT_CM_TRAINING_FAILURE: return {
      ...state,
      exportingIncampTraining: false,
      exportIncampTraining: false,
    }

    case EXPORT_CM_TRAINING_RESET: return {
      ...state,
      exportingIncampTraining: false,
      exportIncampTraining: false,
    }
    
    
    case GET_ALL_ICA_NO_PAGINATION: return {
      ...state,
      fetchingAllIcaNoPagination: true,
    }
    
    case GET_ALL_ICA_NO_PAGINATION_SUCCESS: return {
      ...state,
      fetchingAllIcaNoPagination: false,
      fetchAllIcaNoPaginationSuccess: true,
      allIcaNoPagination: action.payload.data
    }
    
    case GET_ALL_ICA_NO_PAGINATION_FAILURE: return {
      ...state,
      fetchingAllIcaNoPagination: false,
      fetchAllIcaNoPaginationSuccess: false,
    }

    case GET_ALL_ICA_NO_PAGINATION_FAILURE_RESET: return {
      ...state,
      fetchingAllIcaNoPagination: false,
      fetchAllIcaNoPaginationSuccess: false,
      allIcaNoPagination: [],
    }

    default: return state;
  }
}

export default reducers;